import React, { Component } from "react";
import { removeRates } from "../../../../libs/functions";

import ManageEditStripeRates from "./ManageEditStripeRates";

import Swal from "sweetalert2";
import Util from "../../../../libs/util";

class ManageMerchantStripeRatesTable extends Component {
	constructor(props) {
		super(props);

		this.state = {
			rates: props.rates,
			paymentTypes: Object.keys(props.MDRTypes),
		};
	}

	componentDidUpdate(prevProps) {
		if (JSON.stringify(prevProps.rates) !== JSON.stringify(this.props.rates))
			this.setState({
				rates: this.props.rates,
			});
	}

	openModal = () => {
		Util.showModal("manage-edit-stripe-rates");
	};

	deleteRates = () => {
		const { gateway, merchant, retrieveMerchants } = this.props;
		Util.promptConfirmation().then((result) => {
			if (result.value) {
				Swal.fire({
					title: "Removing rates",
					onBeforeOpen: () => {
						Swal.showLoading();
					},
					onOpen: async () => {
						try {
							let status = await removeRates({
								merchantId: merchant.id,
								gateway,
							});
							if (status) {
								Swal.fire({
									icon: "success",
									title: "Rates removed",
								}).then(async () => {
									retrieveMerchants(true);
								});
							}
						} catch (err) {
							Swal.fire({
								icon: "error",
								title: `Unable to remove rates`,
								onClose: () => {},
							});
						}
					},
				});
			}
		});
	};

	render() {
		const {
			merchant,
			MDRTypes,
			gateway,
			baseRate,
			retrieveMerchants,
			readOnly,
		} = this.props;
		const { rates, paymentTypes } = this.state;

		if (rates) {
			const { default: defaultRate, under, ...others } = rates;
			return (
				<div>
					<ManageEditStripeRates
						merchant={merchant}
						MDRTypes={MDRTypes}
						gateway={gateway}
						rates={rates}
						baseRate={baseRate}
						retrieveMerchants={retrieveMerchants}
					/>
					<div>
						<span className="uk-flex uk-flex-middle">
							Transaction Fees
							{!readOnly && (
								<button
									className="uk-margin-left uk-icon-button uk-button-primary"
									uk-icon="icon: fa-solid-pencil-alt; ratio: 0.5"
									type="button"
									onClick={this.openModal}
								/>
							)}
							{!readOnly && (
								<button
									className="uk-margin-small-left uk-icon-button uk-button-danger"
									uk-icon="icon: fa-solid-trash; ratio: 0.5"
									type="button"
									onClick={this.deleteRates}
								/>
							)}
						</span>
						<hr className="uk-margin-small-top uk-margin-small-bottom" />
					</div>
					<div className="uk-overflow-auto" style={{ height: "40vh" }}>
						<div className="view-merchant-rate-table uk-overflow-auto uk-margin-small-bottom">
							<table className="uk-table uk-table-striped uk-table-middle">
								<thead>
									<tr>
										<th>Type</th>
										<th>Percentage</th>
										<th>Fixed Fees</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>Default</td>
										<td>{rates.default.percent}%</td>
										<td>${rates.default.fixed.toFixed(2)}</td>
									</tr>
									{rates.under.map(
										({ amountInCents, percent, fixed }, index) => (
											<tr key={index}>
												<td>Under ${(amountInCents / 100).toFixed(2)}</td>
												<td>{percent}%</td>
												<td>${fixed.toFixed(2)}</td>
											</tr>
										)
									)}
								</tbody>
							</table>
						</div>
						{Object.keys(others).length > 0 && (
							<div className="new-merchant-rate-table uk-overflow-auto uk-margin-bottom">
								<table className="uk-table uk-table-striped uk-table-middle">
									<thead>
										<tr>
											<th>Payment Type</th>
											<th>Percentage</th>
											<th>Fixed Fees</th>
										</tr>
									</thead>
									<tbody>
										{paymentTypes.map((type) => {
											let prefix = `${gateway}.${type}`;
											let paymentRate = rates[type];
											if (paymentRate) {
												return (
													<tr key={`${prefix}-rate`}>
														<td>
															<img
																className="uk-img"
																src={`data:image/*;base64,${MDRTypes[type].image}`}
																width="35"
															/>
															<span className="uk-margin-small-left">
																{MDRTypes[type].label}
															</span>
														</td>
														<td>{paymentRate.percent}%</td>
														<td>
															{paymentRate.fixed
																? `$${paymentRate.fixed.toFixed(2)}`
																: "-"}
														</td>
													</tr>
												);
											}
										})}
									</tbody>
								</table>
							</div>
						)}
					</div>
				</div>
			);
		}
		return null;
	}
}

export default ManageMerchantStripeRatesTable;
